export default __webpack_public_path__ + "static/media/roles-and-rewards.396229cc.svg";